<div class="vq-dialog" role="dialog" aria-labelledby="svq-title">
  <!-- F1 -->
  <div class="vqd-head">
    <div class="t">
      <h2 id="svq-title">Select Vendor Quote</h2>
      <p>For <b>{{ line.name }}</b>. Pick the quote this material should use. You see every change before it is applied.</p>
    </div>
    <button type="button" class="vqd-x" (click)="cancel()" aria-label="Close"><mat-icon>close</mat-icon></button>
  </div>

  <div class="vqd-body">
    <div class="now">
      <span>Now in proposal:</span><b>{{ line.qty }} {{ line.unit }}</b>
      <span>× <b>{{ line.unitCost | currency }}</b></span>
      <span>from <b>{{ line.vendorName || 'No vendor' }}</b></span>
    </div>

    @if (hasExpired) {
      <div class="vqd-switch">
        <span class="t">
          <b>Include expired quotes</b>
          <span class="s">{{ allowExpired ? 'Expired quotes can be picked. Confirm their prices with the vendor.' : 'Turn on to pick a quote that has passed its valid-till date.' }}</span>
        </span>
        <mat-slide-toggle class="b-one-switch" [checked]="allowExpired" (change)="setAllowExpired($event.checked)"
          aria-label="Include expired quotes"></mat-slide-toggle>
      </div>
    }

    <!-- F2: one option per quote that has this material -->
    @for (opt of options; track trackByKey($index, opt)) {
      <label class="opt" [class.sel]="isSelected(opt)" [class.dis]="!canPick(opt)"
        [matTooltip]="blockedReason(opt)">
        <input type="checkbox" [checked]="isSelected(opt)" [disabled]="!canPick(opt)"
          (change)="toggle(opt, $any($event.target).checked)" [attr.aria-label]="opt.vendorName + ' ' + opt.quotationReference">
        <span class="t">
          <b>{{ opt.vendorName }}</b> <span class="muted">· {{ opt.quotationReference }}</span>
          <span class="s">
            {{ opt.itemName }} · {{ opt.qty }} {{ opt.unit }} ·
            @if (opt.isExpired) {
              <span class="vqd-tag exp">Expired {{ formatDate(opt.validTill) }}</span>
            } @else {
              valid till {{ formatDate(opt.validTill) }}
            }
          </span>
        </span>
        <span class="pr">
          @if (opt.hasPrice) {
            <b class="num">{{ opt.unitPrice | currency }}</b><span class="s">per {{ opt.unit || 'unit' }}</span>
          } @else {
            <span class="vqd-tag nop">No price</span>
          }
          @if (canPick(opt) && opt.unitPrice === lowestPrice) {
            <span class="vqd-tag low">Lowest price</span>
          }
          @if (canPick(opt)) {
            <span class="diffv" [ngClass]="priceDiff(opt).cls">{{ priceDiff(opt).text }}</span>
          }
        </span>
        <!-- F3: quantity per vendor when the material is split -->
        @if (isSelected(opt) && count > 1) {
          <span class="xtra">Quantity from this vendor
            <input type="number" min="0" [value]="qtyFor(opt)" (change)="setQty(opt, $any($event.target).value)"
              (click)="$event.preventDefault()" [attr.aria-label]="'Quantity from ' + opt.vendorName"> {{ opt.unit }}
          </span>
        }
      </label>
    }
    @if (!options.length) {
      <div class="vqd-tip"><mat-icon>info</mat-icon><span class="t">No vendor quote on this bid has this material.</span></div>
    }

    @if (count > 1) {
      <div class="vqd-tip warn">
        <mat-icon>error_outline</mat-icon>
        <span class="t">You picked {{ count }} quotes, so this material is split into <b>{{ count }} lines</b>, one per vendor. Set how many each vendor supplies.</span>
      </div>
    }
  </div>

  <!-- F4 -->
  <div class="vqd-foot">
    <span class="note">{{ count ? count + ' selected' : 'Select at least one quote to continue.' }}</span>
    <button type="button" class="vqd-btn" (click)="cancel()">Cancel</button>
    <button type="button" class="vqd-btn vqd-btn-go" (click)="preview()" [disabled]="!count"
      matTooltip="Shows exactly what will change in this proposal. Nothing changes yet.">Preview Changes</button>
  </div>
</div>
